

import {Enum} from "./Enum";

/***********************************************************
 *
 ***********************************************************/

export const enums = {
    AgentLevelEnum: new Enum()
        .add(0, '公司', '公司')
        .add(1, 'L-1', 'L-1')
        .add(2, 'L-2', 'L-2')
        .add(3, 'L-3', 'L-3')
    ,
    AgentNatureEnum: new Enum()
        .add(1, '企业', '企业')
        .add(2, '个人', '个人')
        .add(3, '个体工商户', '个体工商户')
    ,
    AgentStatusEnum: new Enum()
        .add(1, '审核中', '审核中', '审核中')
        .add(2, '正常', '正常', '正常')
        .add(3, '冻结', '冻结', '冻结')
        .add(4, '注销', '注销', '注销')
        .add(5, '签约中', '签约中', '审核通过' )
    ,
    AgentStatusOpt1Enum: new Enum()
        .add(3, '冻结', '冻结')
        .add(4, '注销', '注销')
        .add(5, '审核通过', '审核通过')
    ,
    AgentStatusOpt2Enum: new Enum()
        .add(3, '冻结', '冻结')
        .add(4, '注销', '注销')
    ,
    DevAllotPayFlagEnum: new Enum()
        .add(1, '无款单', '无款单')
        .add(2, '未付款', '未付款')
        .add(3, '已付款', '已付款')
        .add(4, '已免单', '已免单')
    ,
    DevAllotStatusEnum: new Enum()
        .add(1, '途中', '途中')
        .add(2, '签收', '签收')
        .add(3, '拒收', '拒收')
    ,
    DevStorageStatusEnum: new Enum()
        .add(1, '在库', '在库')
        .add(2, '调拨中', '调拨中')
    ,
    DevActiveStatusEnum: new Enum()
        .add(1, '空置', '空置')
        .add(2, '首绑', '首绑')
        .add(3, '点亮', '点亮')
        .add(4, '激活', '激活')
        .add(5, '有效', '有效')
    ,
    DevBindStatusEnum: new Enum()
        .add(1, '未绑定', '未绑定')
        .add(2, '已绑定', '已绑定')
        .add(3, '解绑中', '解绑中')
        .add(4, '绑定中', '绑定中')
    ,
    DevDbStatusEnum: new Enum() // 代理商
        .add('1', '未调拨', '未调拨')
        .add('0', '已调拨', '已调拨')
    ,
    DevFpStatusEnum: new Enum() // 业务员
        .add('0', '未分配业务员', '未分配业务员')
        .add('1', '已分配业务员', '已分配业务员')
    ,
    QrPreSetRateEnum: new Enum() // 预设费率
        .add('1', 0.36, 0.36, '0.36%')
        .add('2', 0.38, 0.38, '0.38%')
        .add('3', 0.43, 0.43, '0.43%')
        .add('4', 0.48, 0.48, '0.48%')
    ,
    ProductChannelEnum: new Enum()
        .add("JH", "KDB", "JH", "聚合KDB")
        .add("SL", "SXF", "SL", "聚合SXF")
        .add("XYF", "XYF", "XYF", "聚合GT")
        .add("QR", "YSF", "QR", "垫资费率: 0.02%，单笔最低0.1元")
        .add("LKL", "LKL", "LKL", "垫资费率: 0.01%，单笔最低0.01元")
    ,
    ProductChannelConvertEnum: new Enum()
        .add('SXF', 'SXF', 'SXF', "HIDE")
        .add('KDB', 'KDB', 'KDB', "HIDE")
        .add('XYF', 'XYF', 'XYF', "HIDE")
        .add('YSF', 'YSF', 'YSF', "SHOW")
        .add('LKL', 'LKL', 'LKL', "SHOW")
    ,
    ProductChannelConvertEnum2: new Enum()
        .add('SXF', '随行付', 'SXF', "HIDE")
        .add('KDB', '开店宝', 'KDB', "HIDE")
        .add('XYF', '国通', 'XYF', "HIDE")
        .add('YSF', '银盛', 'YSF', "SHOW")
        .add('LKL', '拉卡拉', 'LKL', "SHOW")
    ,
    ProductChannelCodeConvertEnum: new Enum()
        .add('JH', 'KDB', 'JH')
        .add('SL', 'SXF', 'SL')
        .add('XYF', 'XYF', 'XYF')
        .add('QR', 'YSF', 'QR')
        .add('LKL', 'LKL', 'LKL')
    ,
    ProductChannelExtConvertEnum: new Enum()
        .add('SXF', '刷脸产品协议', '刷脸产品协议')
        .add('KDB', '聚合产品协议', '聚合产品协议')
        .add('XYF', '国通产品协议', '国通产品协议')
        .add('YSF', '支付码产品协议', '支付码产品协议')
        .add('LKL', '支付码2产品协议', '支付码2产品协议')
    ,
    ProductChannelExtZcdjbConvertEnum: new Enum()
        .add('SXF', '刷脸注册登记表', '刷脸注册登记表')
        .add('KDB', '聚合注册登记表', '聚合注册登记表')
        .add('XYF', '国通注册登记表', '国通注册登记表')
        .add('YSF', '支付码注册登记表', '支付码注册登记表')
        .add('LKL', '支付码2注册登记表', '支付码2注册登记表')
    ,
    ProductChannelExtSettNonlegalAuthConvertEnum: new Enum()
        .add('SXF', '刷脸非法人授权函', '刷脸非法人授权函')
        .add('KDB', '聚合非法人授权函', '聚合非法人授权函')
        .add('XYF', '国通非法人授权函', '国通非法人授权函')
        .add('YSF', '支付码非法人授权函', '支付码非法人授权函')
        .add('LKL', '支付码2非法人授权函', '支付码2非法人授权函')
    ,
    ChannelMchStatusEnum: new Enum()
        .add(-1, '未知状态', '未知状态')
        .add(0, '创建', '创建')
        .add(1, '审核成功', '审核成功')
        .add(2, '审核驳回', '审核驳回')
        .add(3, '进件成功待审核', '进件成功待审核')
        .add(4, '待渠道进件', '待渠道进件')
        .add(5, '待渠道信息变更', '待渠道信息变更')
        .add(6, '进件失败', '进件失败')
        .add(7, '变更成功待审核', '变更成功待审核')
        .add(8, '变更失败', '变更失败')
        .add(9, '变更审核驳回', '变更审核驳回')
        .add(10, '转人工审核', '转人工审核')
        .add(11, '等待预签约', '等待预签约')
    ,
    MchStatusEnum: new Enum()
        .add(0, '停用', '停用')
        .add(1, '正常', '正常')
    ,
    MchNatureEnum: new Enum()
        .add(1, '个体工商户', '个体工商户')
        .add(2, '小微商户', '小微商户')
        .add(3, '企业', '企业')
        .add(4, '事业单位', '事业单位')
        .add(5, '社会组织', '社会组织')
        .add(6, '政府机关', '政府机关')
    ,
    MchCreateWayEnum: new Enum()
        .add(1, 'PC', 'PC')
        .add(2, 'APP', 'APP')
    ,
    MchAuthStatusEnum: new Enum()
        .add('APPLYMENT_STATE_WAITTING_FOR_AUDIT', '审核中', '审核中', '请耐心等待1~2个工作日，微信支付将会完成审核。')
        .add('APPLYMENT_STATE_EDITTING', '编辑中', '编辑中', '可能提交申请发生了错误导致，可用同一个业务申请编号重新提交。')
        .add('APPLYMENT_STATE_WAITTING_FOR_CONFIRM_CONTACT', '待确认联系信息', '待确认联系信息', '请扫描微信支付返回的小程序码确认联系信息(此过程可修改超级管理员手机号)。')
        .add('APPLYMENT_STATE_WAITTING_FOR_CONFIRM_LEGALPERSON', '待账户验证', '待账户验证', '请扫描微信支付返回的小程序码在小程序端完成账户验证。')
        .add('APPLYMENT_STATE_PASSED', '审核通过', '审核通过', '请扫描微信支付返回的小程序码在小程序端完成授权流程。')
        .add('APPLYMENT_STATE_REJECTED', '审核驳回', '审核驳回', '请按照驳回原因修改申请资料，并更换业务申请编码，重新提交申请。')
        .add('APPLYMENT_STATE_FREEZED', '已冻结', '已冻结', '可能是该主体已完成过入驻，请查看驳回原因，并通知驳回原因中指定的联系人扫描微信支付返回的小程序码在小程序端完成授权流程。')
        .add('APPLYMENT_STATE_CANCELED', '已作废', '已作废', '表示申请单已被撤销，无需再对其进行操作。')
        .add('APPLYMENT_STATE_OPENACCOUNT', '已开户', '已开户', '表示该主体已经在微信完成过实名认证。')
    ,
    MchAuthChannelStatusEnum: new Enum()
        .add(-1, '失败', '失败')
        .add(0, '初始', '初始')
        .add(1, '成功', '成功')
        .add(2, '认证中', '认证中')
    ,
    CompanyTypeEnum: new Enum()
        .add(1, '股份有限责任公司', '股份有限责任公司')
        .add(2, '有限责任公司', '有限责任公司')
        .add(3, '非公司企业法人', '非公司企业法人')
        .add(4, '私营合伙企业', '私营合伙企业')
        .add(5, '私营独资企业', '私营独资企业')
        .add(6, '个体', '个体')
    ,
    BusinessTypeEnum: new Enum()
        .add(1, '营业执照', '营业执照')
        .add(2, '营业执照（多证合一）', '营业执照多证合一')
        .add(3, '事业单位法人证书', '事业单位法人证书')
    ,
    SettleTypeEnum: new Enum()
        .add(1, '对公结算', '对公结算')
        .add(2, '法人对私结算', '法人对私结算')
        .add(3, '非法人对私结算', '非法人对私结算')
    ,
    SettleTypeEnum2: new Enum()
        .add(2, '法人对私结算', '法人对私结算')
        .add(3, '非法人对私结算', '非法人对私结算')
    ,
    SettleTypeEnum3: new Enum()
        .add(1, '对公结算', '对公结算')
        .add(2, '对私结算', '对私结算')
    ,
    ImgTypeEnum: new Enum()
        .add(1, '商户照片', '商户照片')
        .add(2, '门店照片', '门店照片')
        .add(3, '结算账户照片', '结算账户照片')
    ,
    UserTypeEnum: new Enum()
        .add(1, '代理商', '代理商')
        .add(2, '商户', '商户')
        .add(3, '门店', '门店')
        .add(4, '终端', '终端')
        .add(5, '客户经理', '客户经理')
        .add(6, '产品渠道', '产品渠道')
        .add(7, '用户支付产品', '用户支付产品')
    ,
    SysAccTypeEnum: new Enum()
        .add(1, '公司', '公司')
        .add(2, '服务商', '服务商')
        .add(3, '客户经理', '客户经理')
        .add(4, '商户', '商户')
    ,
    RateTypeEnum: new Enum()
        .add(0, '普通费率', '普通费率')
        .add(1, 'D0垫资费率', 'D0垫资费率')
        .add(2, '银联大于1000费率', '银联大于1000费率')
        .add(3, '银联小于1000费率', '银联小于1000费率')
        .add(4, '银联优惠费率', '银联优惠费率')
        .add(5, '银联借记卡费率', '银联借记卡费率')
        .add(6, '银联贷记卡费率', '银联贷记卡费率')
    ,
    PaySourceEnum: new Enum()
        .add(1, '码牌', '码牌')
        .add(2, '网关', '网关')
        .add(3, '收银机', '收银机')
        .add(4, '收款单', '收款单')
    ,
    PayWayEnum: new Enum()
        .add('UNIONPAY', '银联', '银联')
        .add('WECHAT', '微信', '微信')
        .add('ALIPAY', '支付宝', '支付宝')
        .add('SZHB', '数币', '数币')
    ,
    PayOrderTypeEnum: new Enum()
        .add(1, '付款', '付款')
        .add(2, '撤销', '撤销')
        .add(3, '退款', '退款')
    ,
    PayModeEnum: new Enum()
        .add('PAY_AUTHCODE', '被扫', '被扫')
        .add('PAY_SCAN', '扫码', '扫码')
        .add('PAY_FACE', '刷脸', '刷脸')
        .add('PAY_CARD', '银行卡', '银行卡')
        .add('PAY_GZH', '主扫', '主扫')
        .add("PAY_MINIAPP_SFT", "收费通", "收费通")
//        .add("PAY_ALI_APP_SFT", "收费通", "收费通")
    ,
    TransTypeEnum: new Enum()
        .add('01', '消费', '消费')
        .add('02', '退款', '退款')
    ,
    TransStatusEnum: new Enum()
        .add(0, '未支付', '未支付')
        .add(1, '已支付', '已支付')
    ,
    TransResultEnum: new Enum()
        .add('0000', '成功', '成功')
        .add('0001', '失败', '失败')
    ,
    MchBillTotalTypeEnum: new Enum()
        .add('terNo', '终端', '终端')
        .add('payWayCode', '支付渠道', '支付渠道')
        .add('payModeCode', '支付方式', '支付方式')
        .add('transDate', '交易日期', '交易日期')
    ,
    MchTotalTypeEnum: new Enum()
        .add('terNo', '终端', '终端')
        .add('payWayCode', '支付渠道', '支付渠道')
        .add('payModeCode', '支付方式', '支付方式')
        .add('transDate', '交易日期', '交易日期')
    ,
    DevTransTotalTypeEnum: new Enum()
        .add('payWayCode', '支付渠道', '支付渠道')
        .add('payModeCode', '支付方式', '支付方式')
        .add('transDate', '交易日期', '交易日期')
    ,
    DevDevActTypeEnum: new Enum()
        .add('payChannelCode', '产品', '产品')
        .add('modelId', '型号', '型号')
        .add('payWayCode', '支付渠道', '支付渠道')
        .add('payModeCode', '支付方式', '支付方式')
        .add('transDate', '交易日期', '交易日期')
    ,


};
